/**
 * 派单规则
 */
import React from 'react';
import styles from './index.module.scss';
import { XSelect, XOKButton, XCancelButton, XInput, showConfirm, XInputNum } from '@/components/xqxc_ui';
import TableContent from './components/TableContent';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import http from '@/assets/api/http';
import { message } from 'antd';
import KeepAlive from '@/routes/KeepAlive';
import { autoPageNum, autopageSize } from '@/assets/config';
import { SearchBox, SearchItem } from '@/components/Layout';
import model from '@/reducers/system/operatingrule/model';


class SendList extends React.PureComponent {

    state = {
        status: {},//规则状态
        ruleName: '',//规则名称
        sendRange: undefined,//推送范围
    }

    componentDidMount() {
        this.props.getSendRuleState({ enumName: 'StateEnum' });//启用状态
    }

    // 新建规则
    _createRule = () => {
        this.props.updateContent('CREAT');
    }

    // 查询触发
    _searchHandle = (useCache) => {
        const { pageNum, pageSize, status, ruleName, sendRange } = this.state;
        this.searchCache = {
            dispatchName: ruleName,//规则名称  
            status: status.code,//规则状态  
            dispatchRange: sendRange,//推送范围
            pageNum: useCache == 'useCache' ? pageNum : autoPageNum, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
            pageSize: useCache == 'useCache' ? pageSize : autopageSize, // 【第2步，当有useCache时使用当前分页状态，否则使用默认分页状态】
        };
        this.props.getSendRuleList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageNum: this.searchCache.pageNum, pageSize: this.searchCache.pageSize }); // 【第3步，缓存查询状态】
    }

    // 重置触发
    _resetHandle = () => {
        this.setState({ status: {}, ruleName: '', sendRange: undefined, }, () => {
            KeepAlive.saveResetFunc(this._searchHandle); // 【第4步：将是否调用重置交给KeepAlive控制】
        });
    }

    // 表格操作
    _tableAction = (item, tabletype, value) => {
        switch (tabletype) {
            case 'editor':
                this.props.updateContent('EDITOR', item);
                break;
            case 'delete':
                showConfirm('您正在删除派单规则，删除后将无法按该规则进行派发推送', '您确定要删除么？', () => {
                    http('/?cmd=com.xqxc.api.pig.mis.biz.rules.DispatchRuleService.deleteDispatch', { id: item }, 'POST').then(() => {
                        message.success('删除成功');
                        this.props.getSendRuleList(this.searchCache);
                    }).catch((error = {}) => {
                        message.error(error.message);
                    });
                }, () => { });
                break;
            case 'switch'://状态
                http('/?cmd=com.xqxc.api.pig.mis.biz.rules.DispatchRuleService.updateStatus', {
                    id: item.id,
                    status: (value === false) ? 0 : 1,
                }, 'POST').then(() => {
                    message.success('修改成功');
                    this.props.getSendRuleList(this.searchCache);
                }).catch((reject = {}) => {
                    message.error(reject.message);
                });
                break;
            case 'radio'://首页规则
                http('/?cmd=com.xqxc.api.pig.mis.biz.rules.DispatchRuleService.doIndex', {
                    id: item.id,
                }, 'POST').then(() => {
                    message.success('修改成功');
                    this.props.getSendRuleList(this.searchCache);
                }).catch((reject = {}) => {
                    message.error(reject.message);
                });
                break;
        }
    }

    // 页面发生变化
    _paginationChange = (pageSize, pageNum) => {
        this.searchCache = { ...this.searchCache, pageSize, pageNum };
        this.props.getSendRuleList(this.searchCache);
        KeepAlive.saveCache({ ...this.state, pageSize, pageNum }); // 【第5步：缓存分页状态】
    }

    render() {
        const { sendRange, ruleName, status } = this.state;
        const { tableList, ruleState } = this.props;
        return (
            <KeepAlive id='4' render={(state) => {
                if (!this.state.__aliveInit) {
                    this.setState({ ...state, __aliveInit: true }, () => {
                        this._searchHandle('useCache'); // 【第1步：调用查询接口初始化数据】
                    });
                }
            }}>
                <div className={styles.flexBoxContainer}>
                    <SearchBox>
                        <SearchItem>
                            <XInput
                                label='规则名称'
                                placeholder='请输入规则名称'
                                bindThis={this}
                                bindName='ruleName'
                                value={ruleName}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInputNum
                                inputStyle={{ width: '150px', }}
                                label='推送范围'
                                placeholder='请输入推送范围'
                                value={sendRange}
                                bindThis={this}
                                bindName='sendRange'
                                precision={0}
                                min={0}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XSelect
                                label='规则状态'
                                placeholder='请选择'
                                renderData={ruleState}
                                bindThis={this}
                                bindName='status'
                                dataIndex='value'
                                keyIndex='code'
                                value={status.value}
                            />
                        </SearchItem>
                        <SearchItem>
                            <XOKButton
                                label='查询'
                                onClick={this._searchHandle}
                            />
                            <XCancelButton
                                label='重置'
                                onClick={this._resetHandle}
                            />
                        </SearchItem>
                    </SearchBox>
                    <div className={styles.operate_box}>
                        <XOKButton style={{ width: '90px' }} label='新建规则' onClick={this._createRule} />
                    </div>
                    <TableContent renderData={tableList} tableAction={this._tableAction} paginationChange={this._paginationChange} />
                </div>
            </KeepAlive>
        );
    }
}

SendList.propTypes = {
    history: PropTypes.object, // 路由history对象
    updateContent: PropTypes.func, // 路由跳转

    tableList: PropTypes.object,
    getSendRuleList: PropTypes.func,//表格数据(action)
    ruleState: PropTypes.array,
    getSendRuleState: PropTypes.func,//规则状态(action)
};

const mapStateToProps = (state) => {
    return {
        tableList: state.operatingrule.sendRuleList,
        ruleState: state.operatingrule.ruleState,
    };
};
export default connect(mapStateToProps, model.actions)(SendList);
